module.exports = "/assets/1040ee14cb13e941de707d9b866a0855.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/7D.png
// module id = 2237
// module chunks = 0